import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import CheckboxIcon from "components/CheckBoxIcon";
import CheckedBoxIcon from "components/CheckedBoxIcon";
import { IEnrolmentOptionItem } from "utils/interfaces/student-enrolment";
import { Control, Controller, FieldValues, Path } from "react-hook-form";
import { SELECT_ALL_VALUE } from "utils/constants/constant";

interface MultiSelectFilterProps<T extends FieldValues> {
  label: string;
  name: Path<T>;
  control: Control<T>;
  options: IEnrolmentOptionItem[];
  onChange: (event: SelectChangeEvent<string[]>) => void;
  renderSelectedValues: (
    selected: string[],
    list: IEnrolmentOptionItem[]
  ) => string;
  isSelectAllSelected?: boolean;
  displaySelectAll?: boolean;
}

const CommonMultiSelectField = <T extends FieldValues>({
  label,
  name,
  control,
  options,
  onChange,
  renderSelectedValues,
  isSelectAllSelected = false,
  displaySelectAll = true,
}: MultiSelectFilterProps<T>) => {
  return (
    <FormControl className="table-select select" fullWidth>
      <InputLabel id={`${name}-select-label`}>{label}</InputLabel>
      <Controller
        control={control}
        name={name}
        render={({ field: { value = [] as string[] } }) => (
          <Select
            labelId={`${name}-select-label`}
            id={`${name}-select`}
            multiple
            value={value}
            onChange={(e) => {
              onChange(e);
            }}
            input={<OutlinedInput label={label} />}
            renderValue={(selected) => renderSelectedValues(selected, options)}
          >
            {displaySelectAll && (
              <MenuItem key={SELECT_ALL_VALUE} value={SELECT_ALL_VALUE}>
                <Checkbox
                  icon={<CheckboxIcon />}
                  checkedIcon={<CheckedBoxIcon />}
                  checked={isSelectAllSelected}
                />
                <ListItemText primary="Select All" />
              </MenuItem>
            )}
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                <Checkbox
                  checked={value.includes(option.value)}
                  icon={<CheckboxIcon />}
                  checkedIcon={<CheckedBoxIcon />}
                />
                <ListItemText primary={option.label} />
              </MenuItem>
            ))}
          </Select>
        )}
      />
    </FormControl>
  );
};

export default CommonMultiSelectField;
